import { render } from "./ToTop.vue?vue&type=template&id=1fef327c&scoped=true"
import script from "./ToTop.vue?vue&type=script&lang=js"
export * from "./ToTop.vue?vue&type=script&lang=js"

import "./ToTop.vue?vue&type=style&index=0&id=1fef327c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fef327c"]])

export default __exports__